export class FileUtils {

    static abrirPdf(base64: string, nomeArquivo: string = 'relatorio.pdf'): void {
        const byteCharacters = atob(base64);
        const byteNumbers = new Uint8Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const blob = new Blob([byteNumbers], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = nomeArquivo;

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }

    /**
     * Baixa um Blob binario ja pronto (ex.: .xlsx/.csv vindos do backend),
     * preservando o MIME do proprio blob (diferente de `abrirPdf`, que crava
     * application/pdf a partir de base64). Cria um <a download> temporario.
     */
    static baixarBlob(blob: Blob, nomeArquivo: string): void {
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = nomeArquivo;

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }

}
